export const COLOUR_OFF = "gray"
export const COLOUR_ON = "#43cf39"
export const STATE_OFF = "OFF"
export const STATE_ON = "ON"